import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import dynamicAPI from '../../api/dynamicAPI';
import '../../css/frontend/activities-page.css';

const url = '/api/view/activities';

export default function Actions() {
    const { t } = useTranslation();

    const { data, isLoading } = useQuery(
        ['view-activities-mini'],
        async () => await dynamicAPI('get', `${url}?page=1&limit=12`, {}),
        {
            retry: 0,
            staleTime: 1000 * 60,
        }
    );

    const items = useMemo(() => data?.data ?? [], [data]);

    return (
        <>
            <Helmet>
                <title>SpaceTime Community | Actions</title>
                <meta
                    name="description"
                    content="Δράσεις — coming soon."
                />
                <meta property="og:title" content="SpaceTime | Activities" />
                <meta property="og:url" content="https://spacetime.community/activities" />
            </Helmet>

            <div className="activities-page">
                <div className="contact-actions">
                    <div className="contact-socials">
                        <a
                            className="social-pill"
                            href="https://facebook.com/spacetime.community/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                <path d="M13 10h2.5l.5-3H13V5.5c0-.9.2-1.5 1.5-1.5H16V1.1C15.6 1 14.7 1 13.7 1 11.6 1 10 2.5 10 5.2V7H7v3h3v9h3v-9z"/>
                            </svg>
                            <span>Facebook</span>
                        </a>

                        <a
                            className="social-pill"
                            href="https://instagram.com/spacetime.community"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 5.5A5.5 5.5 0 1017.5 13 5.5 5.5 0 0012 7.5zm6-1.75a1.25 1.25 0 11-1.25 1.25A1.25 1.25 0 0118 5.75zM12 10a3 3 0 11-3 3 3 3 0 013-3z"/>
                            </svg>
                            <span>Instagram</span>
                        </a>

                        <a
                            className="social-pill"
                            href="https://t.me/spacetime_community"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Telegram"
                        >
                            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                <path d="M9.04 15.46l-.13 3.68a.8.8 0 001.27.65l2.87-2.09 3.98 2.92c.73.53 1.68.13 1.93-.74l3.56-12.2c.28-.97-.62-1.86-1.58-1.55L3.1 10.1c-1.02.33-1 1.8.04 2.09l4.86 1.35 11.33-7.1-10.29 9.02z"/>
                            </svg>
                            <span>Telegram</span>
                        </a>
                    </div>
                </div>

                <div className="content-section-block calendar">
                    <iframe
                        src="https://calendar.google.com/calendar/embed?src=7qqun2cgiioec9colnmpujlifo%40group.calendar.google.com&ctz=Europe%2FAthens&mode=AGENDA"
                        style={{ border: 0, height: '600px' }}
                        frameBorder="0"
                        scrolling="no"
                        title="Google Calendar"
                    />
                </div>

                <main className="activities-body">
                    <div className="activities-block" aria-label="Coming soon">
                        {/*<span className="question-mark" aria-hidden="true">?</span>*/}
                        <p className="activities-list-text">{t('Past Activities')}</p>

                        {!isLoading && items.length > 0 ? (
                            <div className="activities-mini-grid">
                                {items.map((activity) => (
                                    <div
                                        key={activity._id}
                                        className="activities-mini-card"
                                        title={activity.title}
                                        aria-label={activity.title}
                                    >
                                        {activity.image ? (
                                            <img
                                                src={`${data.images_path}${activity.image}`}
                                                alt={activity.title}
                                                className="activities-mini-image"
                                                loading="lazy"
                                            />
                                        ) : (
                                            <div className="activities-mini-placeholder" />
                                        )}

                                        <div className="activities-mini-overlay">
                                            <span className="activities-mini-title">{activity.title}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : null}
                    </div>
                </main>
            </div>
        </>
    );
}